import { API_BASE_URL } from "../index";
import { getCookie } from "../helpers/CookieHandler";
const getselectedLanguage = (langData, successHandler) => {
  const url = new URL(
    API_BASE_URL + "referencedata/translation",
    window.location.origin
  );
  Object.keys(langData).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(langData[key]))
  );
  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then(successHandler);
};

const updateDraftJsonElementValues = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateDraftJsonElementValues`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  }).then(successHandler);
};

const fetchLiveJsonElementValue = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/fetchLiveJsonElementValue`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchDraftJsonElementValue = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/fetchDraftJsonElementValue`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then(successHandler);
};

const getDistinctLiveCountryList = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/getDistinctLiveCountryList`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchJsonKeys = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchJsonKeys`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const revertToPreviousLive = (successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/revertToPreviousLive`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const makeDraftLive = (successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/makeDraftLive`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const createDraft = (successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/createDraft`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const getActiveAndPreviousLiveVersions = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/getActiveAndPreviousLiveVersions`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const deleteDraft = (successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/deleteDraft`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
  }).then(successHandler);
};

const fetchLiveAndDraftDetails = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/fetchLiveAndDraftDetails`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const updateDraftVersionComments = (draftVersionComments, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateDraftVersionComments`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(draftVersionComments),
  }).then(successHandler);
};

const fetchNavMenuList = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/navMenu`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};
const fetchCountryConfig = (country, successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/countryConfig?country=${country}`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const submitCountryConfig = (countryConfig, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}rest/admin/updateCountryConfig`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(countryConfig),
  }).then(successHandler);
};

const submitGmisCase = (queryParams, formData, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(`${API_BASE_URL}inquiry`, window.location.origin);
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "POST",
    credentials: "include",
    body: formData,
    headers: { "X-XSRF-TOKEN": csrfToken },
  }).then(successHandler);
};

const getAllReferenceData = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}referencedata/all`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url)
    .then((resp) => resp.json())
    .then(successHandler);
};

const getAMIData = (payload, successHandler) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}assistant/fetchAmiUserData`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const getPermissions = (queryParams, successHandler) => {
  const url = new URL(
    `${API_BASE_URL}referencedata/permissions`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, encodeURIComponent(queryParams[key]))
  );
  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then(successHandler);
};

const getDownloadZipUrl = (queryParams) => {
  const downloadURL = new URL(
    `${API_BASE_URL}documents/downloadzip`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    downloadURL.searchParams.append(key, queryParams[key])
  );

  return downloadURL;
};

const fetchReportData = (queryParams, successHandler, errorHandler) => {
  const url = new URL(`${API_BASE_URL}reports/delta`, window.location.origin);
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
  })
    .then(successHandler)
    .catch(errorHandler);
};

const fetchCountriesList = (successHandler) => {
  fetch(`${API_BASE_URL}referencedata/countries`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const fetchInternalEmployeeCountry = (successHandler) => {
  fetch(`${API_BASE_URL}referencedata/internalemployee`, {
    credentials: "include",
  }).then(successHandler);
};

const searchDocuments = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}documents/bundleSearch`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const searchPatientDocuments = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}documents/bundleSearchPatient`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const searchCategories = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}documents/categories`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const bundleDocumentDownload = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}documents/bundle`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
  })
    .then(success)
    .catch(failure);
};

const sendMail = (contactInformation, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}contact`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(contactInformation),
  })
    .then(success)
    .catch(failure);
};

const getLocalProductList = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/products`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(success)
    .catch(failure);
};

const updateLocalProductLabel = (productlocal, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/product`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(productlocal),
  })
    .then(success)
    .catch(failure);
};

const getProductIndicationMasterListByAffiliate = (
  queryParams,
  success,
  failure
) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/prodIndMaster`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(success)
    .catch(failure);
};

const getIndicationListByProduct = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/indications`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(success)
    .catch(failure);
};

const updateProductIndicationAssociation = (
  productIndicationAssociation,
  success,
  failure
) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/indicationAssociation`,
    window.location.origin
  );
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(productIndicationAssociation),
  })
    .then(success)
    .catch(failure);
};

const getAdGroupMappigForSearch = (success, failure) => {
  const url = new URL(`${API_BASE_URL}rest/admin/role`, window.location.origin);
  const queryParams = {
    roleName: "DOC_SEARCH",
  };
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(success)
    .catch(failure);
};

const updateSearchAdGroups = (roleAdGroup, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(`${API_BASE_URL}rest/admin/role`, window.location.origin);
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(roleAdGroup),
  })
    .then(success)
    .catch(failure);
};

const addProductByAffiliate = (productAdd, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/affiliateProduct`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(productAdd),
  })
    .then(success)
    .catch(failure);
};

const getAllCongresses = (success, failure) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/congresses`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const createOrUpdateCongress = (congress, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/congress`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(congress),
  })
    .then(success)
    .catch(failure);
};

const createOrUpdateSiteMessage = (siteMsg, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/siteMessage`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(siteMsg),
  })
    .then((response) => {
      try {
        if (response.status === 400) {
          response.text().then((errorMessage) => {
            failure({
              message: `HTTP_STATUS:400:ErrorMessage:${errorMessage}`,
            });
            // throw new Error('HTTP_STATUS:400:ErrorMessage:' + errorMessage)
          });
        } else if (response.status !== 201) {
          failure({ message: `HTTP_STATUS:${response.status}` });
        }

        return response.json();
      } catch (ex) {
        failure(ex);
      }
    })
    .then((data) => success(data))
    .catch((ex) => failure(ex));
};

const deleteSiteMessage = (siteMsgId, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}rest/admin/siteMessage/${siteMsgId}`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: "",
  })
    .then(success)
    .catch(failure);
};

const getAllSiteMessages = (success, failure) => {
  const url = new URL(
    `${API_BASE_URL}rest/admin/siteMessagesAdmin`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const getAssistantProducts = (affiliate, country, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}assistant/products?affiliate=${affiliate}&country=${country}`,
    window.location.origin
  );
  fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const getAssistantCategories = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}assistant/categories`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    //url.searchParams.append(key, encodeURIComponent(queryParams[key]))
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

// const getAssistantCategories = (queryParams, success, failure) => {
//   const url = new URL(
//    `${API_BASE_URL}assistant/categories`,
//     window.location.origin
//   )
//   Object.keys(queryParams).forEach(key =>
//     url.searchParams.append(key, encodeURIComponent(queryParams[key]))
//   )
//   fetch(url, {
//     method: 'GET',
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json'
//     }
//   })
//     .then(response => response.json())
//     .then(success)
//     .catch(failure)
// }

const getAssistantQuestions = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}assistant/questions`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    // url.searchParams.append(key, encodeURIComponent(queryParams[key]))
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

// const getAssistantQuestions = (queryParams, success, failure) => {
//   const url = new URL(
//    `${API_BASE_URL}assistant/questions`,
//     window.location.origin
//   )
//   Object.keys(queryParams).forEach(key =>
//     url.searchParams.append(key, encodeURIComponent(queryParams[key]))
//   )
//   fetch(url, {
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json'
//     }
//   })
//     .then(response => response.json())
//     .then(success)
//     .catch(failure)
// }

const getStabilityProducts = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}stability/products`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const checkStability = (request, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  fetch(`${API_BASE_URL}stability/checkStability`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(request),
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const getKioskCongresses = (success, failure) => {
  const url = new URL(
    `${API_BASE_URL}kiosk/congresses`,
    window.location.origin
  );
  fetch(url, {
    credentials: "include",
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const getKioskDocuments = (queryParams, success, failure) => {
  const url = new URL(`${API_BASE_URL}kiosk/search`, window.location.origin);
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(success)
    .catch(failure);
};

const findMyMSL = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}findmymsl/search`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const siteResources = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}siteresources/resources`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const loadCongressIntegration = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}congressintegration/load`, // 'congressintegration/load/sim'
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const siteMessages = (queryParams, success, failure) => {
  const url = new URL(
    `${API_BASE_URL}sitemessages/search`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(success)
    .catch(failure);
};

const mslMeetingRequest = (queryParams, requestBody, success, failure) => {
  const csrfToken = getCookie("XSRF-TOKEN");
  const url = new URL(
    `${API_BASE_URL}findmymsl/requestmeeting`,
    window.location.origin
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );
  fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(requestBody),
  })
    .then(success)
    .catch(failure);
};

const getAuthToken = (successHandler) => {
  fetch(`${API_BASE_URL}OauthToken/getToken`, {
    credentials: "include",
  })
    .then((resp) => resp.json())
    .then(successHandler);
};

const ValidateAdminUser = (successHandler) => {
  fetch(`${API_BASE_URL}rest/admin/adminPermission?userType=ABBVIE_EMPLOYEE`, {
    credentials: "include",
  }).then(successHandler);
};

export const api = {
  admin: {
    localProduct: {
      getProductList: getLocalProductList,
      updateProductName: updateLocalProductLabel,
    },
    indication: {
      getProductIndicationMasterList: getProductIndicationMasterListByAffiliate,
      getIndicationList: getIndicationListByProduct,
      updateIndicationAssociation: updateProductIndicationAssociation,
    },
    adGroup: {
      getAdGroupMappigForSearch,
      updateSearchAdGroups,
    },
    addProduct: {
      addProductname: addProductByAffiliate,
      ValidateAdminUser: ValidateAdminUser,
    },
    translation: {
      deleteDraft,
      fetchLiveAndDraftDetails,
      updateDraftVersionComments,
      createDraft,
      fetchJsonKeys,
      getDistinctLiveCountryList,
      fetchLiveJsonElementValue,
      fetchDraftJsonElementValue,
      updateDraftJsonElementValues,
      makeDraftLive,
      revertToPreviousLive,
      getActiveAndPreviousLiveVersions,
    },
    manageCountryConfig: {
      submitCountryConfig,
      fetchCountryConfig,
      fetchNavMenuList,
    },
  },
  getselectedLanguage,
  submitGmisCase,
  getAllReferenceData,
  getPermissions,
  getAMIData,
  getDownloadZipUrl,
  fetchReportData,
  fetchCountriesList,
  fetchInternalEmployeeCountry,
  searchDocuments,
  searchPatientDocuments,
  searchCategories,
  bundleDocumentDownload,
  sendMail,
  // FIND MY MSL
  findMyMSL,
  // SITE RESOURCES
  siteResources,
  // CONGRESS INTEGRATION
  loadCongressIntegration,
  // SITE MESSAGES
  siteMessages,
  // DIGITAL ASSISTANT
  getAssistantProducts,
  getAssistantCategories,
  getAssistantQuestions,
  // TEMPERATURE EXCURSION TOOL fka STABILITY TOOL
  getStabilityProducts,
  checkStability,
  // KIOSK
  getKioskCongresses,
  getKioskDocuments,
  getAllCongresses,
  createOrUpdateCongress,
  // SITE MESSAGE ADMIN
  getAllSiteMessages,
  createOrUpdateSiteMessage,
  deleteSiteMessage,
  mslMeetingRequest,
  getAuthToken,
};



// WEBPACK FOOTER //
// ./src/mi-app/index.api.js